import { PortfolioEventTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { z } from "zod";

// Mirrors TimelineContractEventDataDTO. Everything except `eventType` is
// nullish per the backend contract: `portfolioId` and `eventDate` are NULL for
// historical notifications that carry no portfolio link or date, and
// `notificationId` is NULL for category=contract items.
const contractEventDataSchema = z.object({
	portfolioId: z.union([z.string(), z.number()]).transform(String).nullish(),
	eventType: z.nativeEnum(PortfolioEventTypeEnum),
	eventDate: z.string().nullish(),
	notificationId: z.number().nullish(),
});

export type ContractEventData = z.infer<typeof contractEventDataSchema>;

/**
 * `eventType` is required: without it the alert-box deep-link filter cannot be
 * built, and that is the only reason this payload is read during navigation.
 */
export const parseContractEventData = (
	data: unknown,
): ContractEventData | null => {
	const result = contractEventDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
